import { render, staticRenderFns } from "./ConfinementservicePage.vue?vue&type=template&id=0241ceb8&"
import script from "./ConfinementservicePage.vue?vue&type=script&lang=js&"
export * from "./ConfinementservicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports